import { ApiResponse } from "../lib/api";
import { persistAuthTokenFromResponse } from "../lib/cookie-manager";
import { userService } from "../services/user-service";
import { DeviceData, ListData, PublicListData, TransactionData, User, UserAuthResponse, UserVIPData } from "../entry/server/user";
import { Movie, WatchedMovieData, WatchListItemRequest } from "../entry/server/movie";

function persistAuthToken(response: ApiResponse<UserAuthResponse>): void {
    if (response.data) {
        persistAuthTokenFromResponse(response.data);
    }
}

export const userRepo = {
    login: async (username: string, password: string): Promise<ApiResponse<UserAuthResponse>> => {
        const response = await userService.login(username, password);
        persistAuthToken(response);
        return response;
    },
    register: async (username: string, name: string, email: string, password: string, confirmPassword: string): Promise<ApiResponse<UserAuthResponse>> => {
        const response = await userService.register(username, name, email, password, confirmPassword);
        persistAuthToken(response);
        return response;
    },
    sendResetPasswordOtp: async (username: string): Promise<ApiResponse<any>> => {
        return await userService.sendResetPasswordOtp(username);
    },
    resetPassword: async (username: string, code: string, password: string): Promise<ApiResponse<any>> => {
        return await userService.resetPassword(username, code, password);
    },
    getMe: async (): Promise<ApiResponse<{vip: UserVIPData, user: User, unread_notifications_count: number}>> => {
        return await userService.getMe();
    },
    logout: async (): Promise<ApiResponse<any>> => {
        return await userService.logout();
    },
    createList: async (name: string, description: string, is_public: boolean): Promise<ApiResponse<ListData>> => {
        return await userService.createList(name, description, is_public);
    },
    getLists: async (page: number): Promise<ApiResponse<PublicListData[]>> => {
        return await userService.getLists(page);
    },
    getList: async (id: number): Promise<ApiResponse<ListData>> => {
        return await userService.getList(id);
    },
    updateList: async (id: number, name: string, description: string, is_public: boolean): Promise<ApiResponse<ListData>> => {
        return await userService.updateList(id, name, description, is_public);
    },
    deleteList: async (id: number): Promise<ApiResponse<any>> => {
        return await userService.deleteList(id);
    },
    getListMovies: async (id: number, page: number, limit: number): Promise<ApiResponse<Movie[]>> => {
        return await userService.getListMovies(id, page, limit);
    },
    addMovieToList: async (listId: number, movieId: number): Promise<ApiResponse<any>> => {
        return await userService.addMovieToList(listId, movieId);
    },
    removeMovieFromList: async (listId: number, movieId: number): Promise<ApiResponse<any>> => {
        return await userService.removeMovieFromList(listId, movieId);
    },
    getPublicLists: async (page: number): Promise<ApiResponse<PublicListData[]>> => {
        return await userService.getPublicLists(page);
    },
    getPublicList: async (id: number): Promise<ApiResponse<PublicListData>> => {
        return await userService.getPublicList(id);
    },
    updateProfile: async (username: string, name: string, email: string, phone: string, avatar: number): Promise<ApiResponse<User>> => {
        return await userService.updateProfile(username, name, email, phone, avatar);
    },
    updatePassword: async (oldPassword: string, newPassword: string): Promise<ApiResponse<any>> => {
        return await userService.updatePassword(oldPassword, newPassword);
    },
    getDevices: async (): Promise<ApiResponse<DeviceData[]>> => {
        return await userService.getDevices();
    },
    deleteDevice: async (deviceToken: string): Promise<ApiResponse<any>> => {
        return await userService.deleteDevice(deviceToken);
    },
    setPrimaryDevice: async (deviceToken: string, code: string): Promise<ApiResponse<any>> => {
        return await userService.setPrimaryDevice(deviceToken, code);
    },
    sendOtpForPrimaryDevice: async (): Promise<ApiResponse<any>> => {
        return await userService.sendOtpForPrimaryDevice();
    },
    getTransactions: async (page: number): Promise<ApiResponse<TransactionData[]>> => {
        return await userService.getTransactions(page);
    },
    getWalletBalance: async (): Promise<ApiResponse<number>> => {
        return await userService.getWalletBalance();
    },
    saveWatchTime: async (playingTime: string): Promise<ApiResponse<{score: number}>> => {
        return await userService.saveWatchTime(playingTime);
    },
    saveWatchListItem: async (items: WatchListItemRequest[]): Promise<ApiResponse<any>> => {
        return await userService.saveWatchListItem(items);
    },
    getWatchedMovies: async (type: "movie" | "series", page: number): Promise<ApiResponse<WatchedMovieData[]>> => {
        return await userService.getWatchedMovies(type, page);
    },
    removeWatchedMovie: async (id: number): Promise<ApiResponse<any>> => {
        return await userService.removeWatchedMovie(id);
    },
    getFavorites: async (page: number): Promise<ApiResponse<Movie[]>> => {
        return await userService.getFavorites(page);
    },
};
